// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/speed-dial","root":"speed-dial-m__root__2jZPA"};